import { isSlotBookable } from "@/lib/dispatch-time";
import type { PickupAvailabilityStatus } from "@/api.types.v2";

export function pickupSlotsForSelectedDate<
  Slot extends {
    startTime: string;
    bookingLeadMinutes: number;
    availabilityStatus?: PickupAvailabilityStatus | null;
  },
>(slots: Slot[], date: string, dispatchTimeZone: string): Slot[] {
  return slots.filter(
    (slot) =>
      slot.availabilityStatus !== "CLOSED" &&
      slot.availabilityStatus !== "CUTOFF" &&
      isSlotBookable(date, slot, dispatchTimeZone)
  );
}
